/**
 * Marke der Plattform - einzige Stelle fuer Name, Claim und Kontaktangaben.
 *
 * Das Logo liegt als React-Komponente in components/Brand.tsx, das Favicon
 * unter public/favicon.svg. Beide verwenden die Akzentfarbe aus index.css,
 * passen sich also automatisch an, wenn dort die Marke geaendert wird.
 */
export const brand = {
  /** Vollstaendiger Name, z.B. in der Anmeldung und im Seitentitel. */
  name: 'FluxPanel',
  /** Kurzform neben dem Logo in der Seitenleiste. */
  shortName: 'FluxPanel',
  /** Zusatz unter dem Namen. */
  tagline: 'WireGuard Verwaltung',
  /** Erscheint im Browser-Tab. */
  documentTitle: 'FluxPanel - WireGuard Verwaltung',
  /** Hauptdomain der Installation. */
  domain: 'fluxpanel.net',
  supportEmail: 'support@fluxpanel.net',
} as const;
